module.exports = __webpack_public_path__ + "img/puzzle.d15d7e25.svg";